"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBackgroundColor = exports.getColor = void 0;

var getColor = function getColor(name) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'main';
  return function (_ref) {
    var theme = _ref.theme;
    return theme.colors[name][variant];
  };
};

exports.getColor = getColor;

var getBackgroundColor = function getBackgroundColor() {
  return function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.background;
  };
};

exports.getBackgroundColor = getBackgroundColor;